import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please log in");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Set a new password" footer={<Link to="/login" className="font-semibold text-blue-600">Back to login</Link>}>
      {!token ? (
        <p className="text-sm text-red-500">Missing or invalid reset token.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <input data-testid="reset-password" type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
          {error && <p className="text-sm text-red-500">{error}</p>}
          <button data-testid="reset-submit" type="submit" disabled={loading} className={btnCls}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Update password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
